module.exports = __webpack_public_path__ + "static/media/3.56e1bbe7.svg";